<template>
  <div>
    <div :id="id" style="height: 100%"></div>
  </div>
</template>

<script setup>
  import * as echarts from 'echarts'
  import { ref, onMounted, defineExpose, onUnmounted, shallowRef } from 'vue'
  import { getApplicationCounts } from '@/api/dashboard'
  const id = 'reservation'

  //初始化图表
  onMounted(initChart)
  const chart = shallowRef()
  function initChart() {
    let chartDom = document.getElementById(id)
    chart.value = echarts.init(chartDom, 'dark')

    let option = {
      color: ['#7B1FA2', '#FF7043', '#37A2FF', '#FF0087', '#FFBF00'],
      backgroundColor: 'rgba(0, 0, 0, 0)', // 透明背景色
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          label: {
            backgroundColor: '#6a7985',
          },
        },
      },
      legend: {
        data: ['车辆', '人员'],
        left: '10px',
        top: '5px',
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      xAxis: [
        {
          type: 'category',
          boundaryGap: false,
        },
      ],
      yAxis: [
        {
          type: 'value',
        },
      ],
      series: [
        {
          name: '车辆',
          type: 'line',
          stack: 'Total',
          smooth: true,
          lineStyle: {
            width: 0,
          },
          showSymbol: false,
          areaStyle: {
            opacity: 0.8,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: 'rgb(123, 31, 162)', // 紫色
              },
              {
                offset: 1,
                color: 'rgba(123, 31, 162, 0.5)', // 紫色的更浅颜色
              },
            ]),
          },
          emphasis: {
            focus: 'series',
          },
        },
        {
          name: '人员',
          type: 'line',
          stack: 'Total',
          smooth: true,
          lineStyle: {
            width: 0,
          },
          showSymbol: false,
          areaStyle: {
            opacity: 0.8,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: 'rgb(255, 112, 67)', // 橙色
              },
              {
                offset: 1,
                color: 'rgba(255, 112, 67, 0.5)', // 橙色的更浅颜色
              },
            ]),
          },
          emphasis: {
            focus: 'series',
          },
        },
      ],
    }

    chart.value && chart.value.setOption(option)
  }

  //请求数据并配置图表数据
  const timer = ref()
  onMounted(() => {
    fetch()
    timer.value = setInterval(fetch, 60 * 1000)
  })
  onUnmounted(() => clearInterval(timer.value))
  async function fetch() {
    const res = await getApplicationCounts()
    if (res.success) {
      setData(res.data)
    }
  }
  function setData(data) {
    let option = {
      xAxis: [
        {
          data: data?.xAxis || [],
        },
      ],
      series: data?.series || [],
    }

    option && chart.value.setOption(option)
  }

  defineExpose({ chart })
</script>

<style lang="less" scoped></style>
